import { CatalogDetailsActions } from "./CatalogDetails-slice";
import axios from 'axios'
// import '../utils/axios-interceptor'

export const fetchSearchData = (url_data, token) => {
	return async (dispatch) => {
		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const pageData = await fetchData();
			dispatch(CatalogDetailsActions.updatePageData(pageData));
		} catch (error) {
			console.log(error);
		}
	};
};

export const fetchPageData = (url_data, token) => {
	return async (dispatch) => {
		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const pageData = await fetchData();
			dispatch(CatalogDetailsActions.updatePageData(pageData));
		} catch (error) {
			console.log(error);
		}
	};
};

export const sendEnrollmentRequestData = (url_data, requestData, token) => {
	console.log("sendEnrollmentRequestData");
	console.log(url_data);
	console.log(requestData);
	return async (dispatch) => {
		const sendRequest = async () => {
			const response = await axios.post(url_data, JSON.stringify(requestData), {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const responseData = await sendRequest();
			console.log("sendRequestResponse");
			console.log(responseData);
			dispatch(CatalogDetailsActions.cenas(responseData));
		} catch (error) {
			console.log(error);
		}
	};
};
